import React from 'react';

const HeadPhoneSoft: React.FC<React.SVGProps<SVGSVGElement>> = ({
  ...props
}) => {
  return (
    <svg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="64" height="64" rx="4" fill="#E8FEF3" />
      <g clipPath="url(#clip0_3064_6308)">
        <path
          d="M20.4205 29.5163V27.2814C20.4205 21.2136 25.4028 16.2747 31.5228 16.2747H33.767C39.8898 16.2747 44.8693 21.2136 44.8693 27.2814V29.5163H47.1643V27.2814C47.1643 19.9569 41.1544 14 33.767 14H31.5228C24.1354 14 18.1255 19.9569 18.1255 27.2814V29.5163H20.4205Z"
          fill="#1D1D1B"
        />
        <path
          d="M46.9986 25.3168L45.5911 25.2102C42.6125 24.9846 40.0162 27.234 39.7922 30.2343L39.4379 34.9807C39.2139 37.9811 41.4471 40.5962 44.4258 40.8218L45.8332 40.9284C48.8119 41.154 51.4082 38.9046 51.6321 35.9043L51.9865 31.1579C52.2104 28.1576 49.9773 25.5424 46.9986 25.3168Z"
          fill="#1D1D1B"
        />
        <path
          d="M18.1799 40.8496L19.5114 40.7488C22.4901 40.5232 24.7232 37.9081 24.4993 34.9078L24.1344 30.0196C23.9104 27.0192 21.3141 24.7699 18.3354 24.9955L17.004 25.0963C14.0253 25.3219 11.7922 27.937 12.0161 30.9374L12.381 35.8256C12.605 38.8259 15.2013 41.0752 18.1799 40.8496Z"
          fill="#1D1D1B"
        />
        <path
          d="M44.1384 38.9109C43.619 43.7987 39.5597 47.515 34.7383 47.6344L34.8032 49.0533C34.871 49.0533 34.9415 49.0533 35.0093 49.0504C40.4997 48.8002 45.0756 44.4697 45.564 38.8484L44.1412 38.9138L44.1384 38.9109Z"
          fill="#1D1D1B"
        />
        <path
          d="M19.4665 29.5163V27.2814C19.4665 21.2136 24.367 16.2747 30.3939 16.2747H32.6013C38.6253 16.2747 43.5287 21.2136 43.5287 27.2814V29.5163H45.7869V27.2814C45.7869 19.9569 39.873 14 32.6013 14H30.3939C23.1222 14 17.2083 19.9569 17.2083 27.2814V29.5163H19.4665Z"
          fill="#008E5A"
        />
        <path
          d="M43.5821 38.561C42.8454 43.4204 38.6195 46.949 33.7981 46.8466V48.2655C33.8658 48.2655 33.9364 48.2712 34.0042 48.2712C39.5003 48.2712 44.2653 44.154 45.0049 38.561H43.5793H43.5821Z"
          fill="#008E5A"
        />
        <path
          d="M34.369 46.5515L32.9728 46.6573C32.1115 46.7225 31.4658 47.4787 31.5306 48.3462L31.5452 48.5418C31.61 49.4094 32.3606 50.0597 33.2219 49.9945L34.6181 49.8888C35.4794 49.8235 36.1251 49.0674 36.0603 48.1999L36.0457 48.0042C35.981 47.1367 35.2303 46.4863 34.369 46.5515Z"
          fill="#1D1D1B"
        />
        <path
          d="M34.1512 45.9698L32.755 46.0755C31.8938 46.1407 31.2481 46.8969 31.3128 47.7644L31.3274 47.96C31.3922 48.8276 32.1429 49.478 33.0041 49.4127L34.4003 49.307C35.2616 49.2418 35.9073 48.4856 35.8425 47.6181L35.8279 47.4224C35.7632 46.5549 35.0125 45.9045 34.1512 45.9698Z"
          fill="#00D483"
        />
        <path
          d="M42.8765 23.5367C42.8765 23.5367 43.2265 24.4665 43.3733 25.4275C43.3733 25.4275 44.5589 25.0096 45.7106 25.1347C45.7106 25.1347 45.5187 24.2504 45.0077 22.7349L42.8793 23.5367H42.8765Z"
          fill="#1D1D1B"
        />
        <path
          d="M42.8765 23.477C42.8624 23.477 42.8483 23.4684 42.8427 23.4542C42.837 23.4372 42.8427 23.4173 42.8624 23.4087L44.3275 22.8088L42.885 23.2211C42.8681 23.2267 42.8483 23.2154 42.8427 23.1983C42.837 23.1813 42.8455 23.1613 42.8624 23.1528L44.638 22.4562C44.6549 22.4505 44.6775 22.4562 44.6832 22.4761C44.6888 22.4932 44.6832 22.5159 44.6634 22.5216L43.5851 22.9453L44.9287 22.5614C44.9457 22.5586 44.9654 22.5671 44.9711 22.5841C44.9767 22.6012 44.9711 22.6211 44.9513 22.6296L43.8532 23.0789L44.9937 22.7007C45.0134 22.695 45.0332 22.7036 45.0388 22.7235C45.0445 22.7434 45.036 22.7633 45.0163 22.769L42.8878 23.4741C42.8878 23.4741 42.8793 23.4741 42.8765 23.4741V23.477Z"
          fill="#1D1D1B"
        />
        <path
          d="M43.0458 40.5912C43.0458 40.5912 43.6781 40.8358 44.4939 40.8841L44.1156 41.9333L42.6873 41.4073L43.0429 40.5884L43.0458 40.5912Z"
          fill="#1D1D1B"
        />
        <path
          d="M17.3833 25.1091C17.3833 25.1091 18.6592 25.2313 19.5964 25.5782L20.017 23.8267L17.8463 23.1926C17.8463 23.1926 17.4934 24.2731 17.3833 25.1091Z"
          fill="#1D1D1B"
        />
        <path
          d="M36.0565 48.1176C36.0565 48.1176 36.0452 47.3215 35.6021 46.7158C35.6021 46.7158 35.8138 47.0229 35.8476 47.6712C35.8815 48.3195 36.0565 48.1176 36.0565 48.1176Z"
          fill="#1D1D1B"
        />
        <path
          d="M36.065 48.2826C36.065 48.2826 36.065 48.2826 36.0622 48.2826C36.0425 48.2826 36.0283 48.2627 36.0312 48.2428C36.0312 48.2371 36.0961 47.6457 35.7461 46.8723C35.7376 46.8552 35.7461 46.8353 35.7602 46.8268C35.7743 46.8182 35.7969 46.8239 35.8082 46.8381C35.8194 46.8524 36.0566 47.2135 36.2316 47.9044C36.2372 47.9243 36.2259 47.9414 36.2062 47.9471C36.1864 47.9527 36.1667 47.9414 36.1638 47.9215C36.1215 47.7565 36.0763 47.6087 36.0312 47.4807C36.1384 47.9357 36.1074 48.2342 36.1046 48.2513C36.1046 48.2684 36.0876 48.2826 36.0707 48.2826H36.065Z"
          fill="#1D1D1B"
        />
        <path
          d="M20.2484 40.6396C20.2484 40.6396 19.3649 40.8159 18.1793 40.8813C16.9937 40.9467 18.0042 39.2065 18.0042 39.2065L20.2484 40.6424V40.6396Z"
          fill="#1D1D1B"
        />
        <path
          d="M46.676 40.9268L44.5532 41.0405L44.6577 40.8927C44.6577 40.8927 44.8694 40.8898 45.194 40.8813C45.5186 40.8728 46.676 40.9268 46.676 40.9268Z"
          fill="#1D1D1B"
        />
        <path
          d="M48.5308 25.6663C48.5308 25.6663 47.3791 25.1914 45.4087 25.1118C45.4087 25.1118 46.8455 25.1147 48.0311 25.6663C49.2167 26.2179 48.5308 25.6663 48.5308 25.6663Z"
          fill="#1D1D1B"
        />
        <path
          d="M12.3825 35.8529C12.6065 38.8532 15.2021 41.1027 18.18 40.8771C21.158 40.6516 23.3905 38.0365 23.1665 35.0362L22.8014 30.1452C22.5774 27.1448 19.9818 24.8954 17.0039 25.1209C14.026 25.3465 11.7935 27.9616 12.0174 30.9619L12.3825 35.8529Z"
          fill="#00D483"
        />
        <path
          d="M50.5808 30.9664C50.8048 27.966 48.5723 25.3509 45.5944 25.1254C42.6165 24.8999 40.0208 27.1493 39.7969 30.1496L39.4318 35.0406C39.2078 38.041 41.4403 40.656 44.4182 40.8816C47.3961 41.1071 49.9917 38.8577 50.2157 35.8574L50.5808 30.9664Z"
          fill="#00D483"
        />
      </g>
      <defs>
        <clipPath id="clip0_3064_6308">
          <rect
            width="40"
            height="36"
            fill="white"
            transform="translate(12 14)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default HeadPhoneSoft;
